import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Popover } from "antd";
import dayjs from "dayjs";
import { WarningFilled } from "@ant-design/icons";
import { todayAtMidnight, isBeforeNow, lessThanOneHourFromNow } from "../../../swzutils/DateUtil";
const ConsignmentDueWarningIcon = ({ consignment }) => {
    if (!consignment) {
        return null;
    }
    const deliveryFromDayjs = dayjs(consignment.deliveryFrom);
    const deliveryTo = ("revisedDeliveryTo" in consignment && consignment.revisedDeliveryTo)
        ? consignment.revisedDeliveryTo
        : consignment.deliveryTo;
    if (!deliveryTo) {
        return null;
    }
    const deliveryToDayjs = dayjs(deliveryTo);
    const allDay = deliveryFromDayjs.isSame(deliveryToDayjs, 'day') && deliveryFromDayjs.format('HH:mm') == "00:00";
    const isNotCompleted = consignment.status !== "COMPLETED" && consignment.status !== "CANCELLED";
    const overdue = allDay ? isNotCompleted && deliveryFromDayjs.isBefore(todayAtMidnight()) : isNotCompleted && isBeforeNow(deliveryTo);
    const isUnassignedOrAssigned = consignment.status === "UNASSIGNED" || consignment.status === "ASSIGNED";
    const dueSoon = !allDay && isUnassignedOrAssigned && lessThanOneHourFromNow(deliveryTo);
    if (dueSoon && !overdue) {
        return (_jsxs(Popover, { destroyOnHidden: true, content: _jsx("p", { style: { width: "250px" }, children: "Consignment due within the hour but not started" }), title: "Consignment Due", children: [_jsx(WarningFilled, { style: { fontSize: '14px', color: "#f4b400" } }), "\u00A0"] }));
    }
    if (overdue) {
        return (_jsxs(Popover, { destroyOnHidden: true, content: _jsx("p", { style: { width: "250px" }, children: "Consignment delivery time is in the past however the consignment is not completed" }), title: "Consignment Overdue", children: [_jsx(WarningFilled, { style: { fontSize: '14px', color: "#d73d32" } }), "\u00A0"] }));
    }
    return null;
};
export default ConsignmentDueWarningIcon;
